import styled from 'styled-components';

/* ─── Recherche utilisateurs ─── */
export const SearchField = styled.div`
    position: relative;
    max-width: 520px;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 7px 10px;
    font-family: inherit;
    font-size: 0.85rem;
    color: ${(p) => p.theme.text};
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.borderStrong};
    border-radius: ${(p) => p.theme.radius.sm};
    transition: border-color 0.12s ease;

    &:focus {
        outline: none;
        border-color: ${(p) => p.theme.accent};
    }
    &::placeholder { color: ${(p) => p.theme.text3}; }
    &:disabled {
        background: ${(p) => p.theme.surface2};
        cursor: not-allowed;
    }
`;

export const SearchLoading = styled.div`
    margin-top: 5px;
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text3};
`;

export const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    padding: 4px;
    max-height: 280px;
    overflow-y: auto;
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.border};
    border-radius: ${(p) => p.theme.radius.sm};
    box-shadow: ${(p) => p.theme.shadowMd};
`;

export const DropdownItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 7px 10px;
    border-radius: ${(p) => p.theme.radius.sm};
    cursor: pointer;
    transition: background 0.12s ease;

    &:hover { background: ${(p) => p.theme.surface3}; }
`;

export const UserInfo = styled.div`
    min-width: 0;
`;

export const UserName = styled.div`
    font-size: ${(p) => p.theme.type.table};
    font-weight: 600;
    color: ${(p) => p.theme.text};
`;

export const UserEmail = styled.div`
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text3};
`;

export const UserDepartment = styled.div`
    flex-shrink: 0;
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text2};
`;

export const NoResults = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    padding: 10px;
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text3};
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.border};
    border-radius: ${(p) => p.theme.radius.sm};
    box-shadow: ${(p) => p.theme.shadowMd};
`;

/* ─── Étiquettes des utilisateurs sélectionnés ─── */
export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
`;

export const UserTag = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 4px 3px 10px;
    font-size: ${(p) => p.theme.type.caption};
    background: ${(p) => p.theme.accentSoft};
    color: ${(p) => p.theme.accentText};
    border-radius: ${(p) => p.theme.radius.pill};
`;

export const TagRemove = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    font-family: inherit;
    font-size: 0.95rem;
    line-height: 1;
    color: inherit;
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.12s ease;

    &:hover:not(:disabled) {
        background: ${(p) => p.theme.surface};
    }
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

export const SelectedCount = styled.div`
    margin-top: 8px;
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text3};
`;

/* ─── Suivi de migration ─── */
const statusColor = (p) => ({
    complete: p.theme.ok,
    error: p.theme.danger,
    'in-progress': p.theme.accent,
    pending: p.theme.border,
}[p.$status] || p.theme.border);

export const MigrationUserCard = styled.div`
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.border};
    border-left: 3px solid ${statusColor};
    border-radius: ${(p) => p.theme.radius.sm};
    padding: 12px 14px;
    margin-bottom: 10px;

    &:last-child { margin-bottom: 0; }
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
`;

export const CardUserName = styled.div`
    font-size: ${(p) => p.theme.type.table};
    font-weight: 700;
    color: ${(p) => p.theme.text};
`;

export const CardUserEmail = styled.div`
    font-size: ${(p) => p.theme.type.caption};
    color: ${(p) => p.theme.text3};
`;

export const CardLogs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid ${(p) => p.theme.border};
`;

const logColor = (p) => ({
    error: p.theme.danger,
    warning: p.theme.warn,
    success: p.theme.ok,
    pending: p.theme.text2,
}[p.$variant] || p.theme.text2);

export const LogEntry = styled.div`
    display: grid;
    grid-template-columns: 18px minmax(0, 1fr) auto;
    align-items: baseline;
    gap: 8px;
    padding: 3px 0;
    font-size: ${(p) => p.theme.type.caption};

    i {
        font-size: 0.95rem;
        color: ${logColor};
        justify-self: center;
    }
`;

export const LogStep = styled.span`
    color: ${(p) => p.theme.text};
    overflow-wrap: anywhere;
`;

export const LogStatus = styled.span`
    color: ${logColor};
    text-align: right;
    overflow-wrap: anywhere;
`;
